import React, { useState } from 'react';
import { KI_GROUPS, QUALITY_SCORE_WEIGHTS } from '../shared/kiPromptsData';
import { ChevronDown, ChevronRight, Brain } from 'lucide-react';

const GROUP_COLORS = {
  purple: 'border-purple-300 bg-purple-50 text-purple-900',
  blue: 'border-blue-300 bg-blue-50 text-blue-900',
  cyan: 'border-cyan-300 bg-cyan-50 text-cyan-900',
  indigo: 'border-indigo-300 bg-indigo-50 text-indigo-900',
  green: 'border-green-300 bg-green-50 text-green-900',
  amber: 'border-amber-300 bg-amber-50 text-amber-900',
  rose: 'border-rose-300 bg-rose-50 text-rose-900',
};

const totalPrompts = KI_GROUPS.reduce((sum, g) => sum + g.prompts.length, 0);

export default function SectionKIFunktionen() {
  const [open, setOpen] = useState({ complaint_analysis: true });

  const toggle = (k) => setOpen(prev => ({ ...prev, [k]: !prev[k] }));

  return (
    <div className="space-y-4" data-testid="section-ki-funktionen">
      <div>
        <h3 className="text-base font-bold text-slate-800 mb-1 flex items-center gap-2">
          <Brain className="w-4 h-4 text-purple-600" />
          KI-Funktionen — {totalPrompts} Prompts in {KI_GROUPS.length} Gruppen
        </h3>
        <p className="text-xs text-slate-500">
          Vollständige Übersicht aller KI-gestützten Funktionen. Alle Prompts sind versioniert
          und können unter <em>KI-Konfiguration</em> angepasst werden.
        </p>
      </div>

      <div className="p-2.5 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-900">
        <strong>Wichtig:</strong> KI liefert ausschließlich <strong>Vorschläge</strong>.
        Die finale Entscheidung trifft immer der verantwortliche Bearbeiter.
      </div>

      <div className="space-y-2">
        {KI_GROUPS.map(g => (
          <div key={g.key} className="rounded-lg border border-slate-200 overflow-hidden">
            <button
              onClick={() => toggle(g.key)}
              className={`w-full px-3 py-2 flex items-center justify-between font-semibold text-sm border-l-4 ${GROUP_COLORS[g.color]} hover:brightness-95 transition`}
              data-testid={`ki-group-${g.key}`}
            >
              <span className="flex items-center gap-2">
                {open[g.key] ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
                {g.name}
                <span className="text-[10px] font-mono font-normal opacity-70">({g.prompts.length})</span>
              </span>
            </button>

            {open[g.key] && (
              <div className="bg-white divide-y divide-slate-100">
                {g.prompts.map(p => (
                  <div key={p.id} className="p-3 text-xs" data-testid={`ki-prompt-${p.id}`}>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="font-mono text-[10px] px-1.5 py-0.5 rounded bg-slate-800 text-white">{p.id}</span>
                      <span className="font-semibold text-slate-800">{p.name}</span>
                      {p.step && <span className="ml-auto text-[10px] font-mono text-slate-500">Step: {p.step}</span>}
                    </div>
                    <div className="text-slate-600 mb-1">{p.description}</div>
                    {p.rules && <div className="text-slate-500 text-[11px]"><strong>Regeln:</strong> {p.rules}</div>}
                    {p.trafficLight && <div className="text-slate-500 text-[11px]"><strong>Ampel:</strong> {p.trafficLight}</div>}
                    {p.endpoint && <div className="font-mono text-[10px] text-slate-400 mt-1 truncate">{p.endpoint}</div>}

                    {p.id === 'p01' && (
                      <div className="mt-2 overflow-x-auto">
                        <table className="w-full text-[10px] border-collapse">
                          <thead>
                            <tr className="bg-slate-100">
                              <th className="text-left p-1.5">D-Schritt</th>
                              <th className="text-right p-1.5">Gewicht</th>
                            </tr>
                          </thead>
                          <tbody>
                            {QUALITY_SCORE_WEIGHTS.map((w, i) => (
                              <tr key={i} className="border-t border-slate-100">
                                <td className="p-1.5">{w.step}</td>
                                <td className="p-1.5 text-right font-mono">{w.weight}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
